import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TapCheckout from "pages/Authentication/TapCheckOut";
import Spinners from "components/common/Spinners";
import {
  buySubscription,
  getAllPlans,
  myCurrentSubscription,
} from "store/actions/subscriptionSlice";
import { CurrencySymbol, formatPlanType } from "components/common/Utils";
import { showAlert } from "store/reducers/alertReducer";
import planBenefitImage from "../../assets/images/icons/checked.svg";

const SubscriptionCheckout = () => {
  const { loading, isLoading, allPlans, paymentMethod } = useSelector(
    (state) => state.Subscriptions
  );
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Example local state/handlers (you may already have these in real code)
  const [cardType, setCardType] = useState(null);
  const [planType, setPlanType] = useState(null);
  const [isRedirectionEnabled, setisRedirectionEnabled] = useState(false);

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const selectedPlan = query.get("selectedPlan");

  const handlePurchaseSubscription = (tapTokenId) => {
    const storedPayload = JSON.parse(
      sessionStorage.getItem("subscriptionPayload") || "{}"
    );

    const payload = {
      ...storedPayload,
      paymentDetails: {
        method: "CARD",
        sourceToken: tapTokenId,
        sourceTokenType: "TOKEN",
      },
    };

    dispatch(buySubscription(payload))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload;
        if (statusCode === 200 && success) {
          const { shouldRedirect, redirectUrl } = data || {};
          if (shouldRedirect) {
            window.location.href = redirectUrl;
            setisRedirectionEnabled(true);
          } else {
            navigate("/welcome");
          }
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  const handleApplePay = () => {
    // Apple Pay logic goes here
  };

  const [checked, setChecked] = useState(
    selectedPlan === "Professional" || false
  );
  const isProfessional = checked;
  useEffect(() => {
    dispatch(getAllPlans());
  }, [checked]);
  const currentPlan = allPlans?.find(
    (plan) => plan.name === (isProfessional ? "Professional" : "Starter")
  );
  console.log("currentPlan", currentPlan);
  const basePrice = currentPlan?.price ?? 0;

  const finalPrice = currentPlan?.discountedPrice ?? basePrice;
  const baseTotalDue = finalPrice;
  const [totalDue, setTotalDue] = useState(baseTotalDue);
  useEffect(() => {
    setTotalDue(finalPrice);
  }, [checked, finalPrice]);

  const handlePlanTypeSelection = (nextChecked) => {
    setChecked(nextChecked);
    setTotalDue(finalPrice);
  };
  useEffect(() => {
    if (allPlans && currentPlan && typeof totalDue === "number") {
      const payloadData = {
        billingCycle: "monthly", // Due to we are converting each plan in monthly
        code: "",
        planId: currentPlan.id,
      };

      sessionStorage.setItem(
        "subscriptionPayload",
        JSON.stringify(payloadData)
      );
    }
  }, [checked, totalDue, allPlans, currentPlan]);

  const getMonthlyPrice = (plan) => {
    if (!plan?.discountedPrice) return 0;
    return plan?.billingCycle === "yearly"
      ? (plan.discountedPrice / 12).toFixed(2)
      : plan.discountedPrice;
  };

  const getBasePrice = (plan) => {
    if (!plan?.price) return 0;
    return plan?.billingCycle === "yearly"
      ? (plan.price / 12).toFixed(2)
      : plan.price;
  };

  const monthlyPrice = getMonthlyPrice(currentPlan);

  return (
    <div
      className={`two_column_pg subscribe_pg subscription_checkout_page ${
        isLoading ? "" : ""
      }`}
    >
      <div className="container">
        <div className="tcp_inner">
          <div className="left_inner">
            <div className="left">
              <h2 className="text_white bold">
                {" "}
                {t("Subscribe to Workspace")}{" "}
              </h2>
              <div className="plan_buttons">
                {/* {allPlans.map((item) => (
                                    !item.isCustom && <button key={item.id}>{item.name}</button>
                                ))} */}
                <button
                  type="button"
                  onClick={() => handlePlanTypeSelection(false)}
                  className={!checked ? "active" : ""}
                >
                  {t("Starter")}
                </button>
                <button
                  type="button"
                  onClick={() => handlePlanTypeSelection(true)}
                  className={checked ? "active" : ""}
                >
                  {t("Professional")}
                </button>
              </div>
              <div className="plan">
                <h6 className="bold plan_type">
                  {isProfessional ? t("Professional") : t("Starter")}{" "}
                  {t("Plan")}
                </h6>
                {currentPlan?.highlightDescription && (
                  <h2 className="plan_highlight">
                    {i18n.language === "ar"
                      ? currentPlan?.highlightDescriptionAr
                      : currentPlan?.highlightDescription}
                  </h2>
                )}
                <p className="plan_description">
                  {i18n.language === "ar"
                    ? currentPlan?.descriptionAr || currentPlan?.description
                    : currentPlan?.description}
                </p>
                <div className="plan_benefits_points">
                  <ul>
                    {currentPlan?.features.map((feature) => (
                      <li key={feature._id}>
                        <img
                          src={planBenefitImage}
                          width={18}
                          height={18}
                          alt="Work Space Logo"
                        />
                        <span>
                          {i18n.language === "ar"
                            ? feature.titleAr
                            : feature.title}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                {basePrice !== finalPrice && (
                  <div className="base_price">
                    <CurrencySymbol height="18" width="18" />
                    {getBasePrice(currentPlan)}
                  </div>
                )}
                <div className="plan_price">
                  <div className="final_price price">
                    <CurrencySymbol height="18" width="18" />
                    {getMonthlyPrice(currentPlan)}
                    {" /"}
                    {t("Month")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right_inner">
            <div className="right">
              <div className="payment_container">
                <h2 className="text_primary bold mb_45">
                  {t("Payment Method")}
                </h2>
                <TapCheckout
                  isRedirectionEnabled={isRedirectionEnabled}
                  totalDue={totalDue}
                  monthlyPrice={monthlyPrice}
                  isLoading={isLoading}
                  handlePurchaseSubscription={handlePurchaseSubscription}
                  handleApplePay={handleApplePay}
                  setCardType={setCardType}
                  paymentMethod={paymentMethod}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCheckout;
